// Build a safe onsubmit confirm() attribute (MT-051): JSON.stringify makes the
// message a valid JS string literal (quotes in record names included), and the
// handler is then entity-escaped for the HTML-attribute context.
function confirmSubmitAttr(message) {
    var js = 'return confirm(' + JSON.stringify(String(message)) + ');';
    return 'onsubmit="' + js.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;') + '"';
}

// Entity-escape a value before it is concatenated into HTML. Every DataTables
// render callback that shows text a resident can set (names, room numbers,
// emails) must pass it through here, or that text runs as markup in the staff
// member's browser (F02).
function escapeHtml(value) {
    if (value === null || value === undefined) {
        return '';
    }
    return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}

/**
 * The first validation message in a refused (422) JSON reply, or a fallback.
 */
function firstServerError(xhr, fallback) {
  var body = xhr && xhr.responseJSON;
  if (body && body.errors) {
    var messages = [].concat.apply([], Object.keys(body.errors).map(function (k) { return body.errors[k]; }));
    if (messages.length) { return messages[0]; }
  }
  return (body && body.message) ? body.message : fallback;
}

// require('./bootstrap');
var $ = require('jquery');
window.$ = window.jQuery = $;
window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle.js');
require('select2');

// drag drop upload
import Dropzone from "dropzone";
Dropzone.autoDiscover = false;

// datatables
import dt from 'datatables.net-bs5';
import 'datatables.net-rowreorder-bs5';
import 'datatables.net-select-bs5';
import 'datatables.net-responsive-bs5';

// Hide pagination controls when only one page of results exists
$.extend($.fn.dataTable.defaults, {
  drawCallback: function() {
    var wrapper = $(this).closest('.dataTables_wrapper');
    var pagination = wrapper.find('.dataTables_paginate');
    pagination.toggle(this.api().page.info().pages > 1);
  }
});

// Suppress DataTables' built-in AJAX error alert — let the global ajaxError handler
// redirect to login on 401/419 instead of showing a raw "Ajax error" popup.
$.fn.dataTable.ext.errMode = 'none';

// calendar
import { Calendar } from '@fullcalendar/core';
import interactionPlugin from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import {usersModule} from './users';


// Fancy popups
import Swal from 'sweetalert2'

// sections
require('./announcements');
require('./sortlist');
require('./userlevel');
require('./dateinputs');
/**
 * The active brand colour, read from the CSS custom property that
 * app_theme.blade.php sets from the selected property's theme.
 *
 * Dialog buttons and calendar feeds used to hardcode the legacy orange, so
 * they stayed orange no matter which property was selected. Reading the
 * variable means they follow the theme, and the fallback matches the
 * $primary baseline in app.scss for the case where no property is chosen.
 *
 * Global rather than exported: the files below are plain scripts required
 * into this bundle, not modules with their own imports.
 */
window.kliqPrimaryColour = function () {
  var value = getComputedStyle(document.documentElement)
    .getPropertyValue('--bs-primary');

  return (value && value.trim()) || '#616647';
};

require('./properties');
require('./events');
require('./news');
require('./gallery');
require('./spaces');
require('./parcelcollections');
require('./reports');
require('./password-validation');

/**
 * Global AJAX error handler — redirect to login on session expiry (401/419).
 */
$(document).ajaxError(function(event, jqXHR) {
  if (jqXHR.status === 401 || jqXHR.status === 419) {
    window.location.href = '/login';
  }
});

/**
 * Password visibility toggle
 */
$(document).on('click', '.toggle-password', function() {
  var targetId = $(this).data('target');
  var input = document.getElementById(targetId);
  if (input) {
    var isPassword = input.type === 'password';
    input.type = isPassword ? 'text' : 'password';
    $(this).find('i').toggleClass('fa-eye fa-eye-slash');
  }
});

/**
 * Export button spinner — shows a loading state on PDF/CSV export buttons
 * while the file is being generated. Resets after a timeout since file
 * downloads don't trigger a page navigation event.
 */
$(document).on('click', '.btn-export', function(e) {
  var btn = $(this);
  var originalHtml = btn.html();
  btn.html('<i class="fa fa-spinner fa-spin fa-fw"></i> Generating...');
  btn.css('pointer-events', 'none');

  // Reset after 30 seconds (file download won't trigger page change)
  setTimeout(function() {
    btn.html(originalHtml);
    btn.css('pointer-events', '');
  }, 30000);
});

/**
 * Sidebar scroll — make sidebar sticky and independently scrollable
 * so it stays visible while the main content scrolls.
 */
(function() {
  var sidebar = document.getElementById('sidebar-desktop');
  if (!sidebar) return;

  // Make sidebar sticky with its own scroll
  sidebar.style.position = 'sticky';
  sidebar.style.top = '0';
  sidebar.style.maxHeight = '100vh';
  sidebar.style.overflowY = 'auto';

  // Restore scroll position after a short delay to ensure layout is complete
  var saved = sessionStorage.getItem('sidebarScroll');
  if (saved) {
    requestAnimationFrame(function() {
      sidebar.scrollTop = parseInt(saved, 10);
    });
  }

  // Save scroll position before navigation
  window.addEventListener('beforeunload', function() {
    sessionStorage.setItem('sidebarScroll', sidebar.scrollTop);
  });
})();

/**
 * Session keep-alive — pings the server every 15 minutes while the tab is
 * visible and the user has interacted recently (within the last 20 minutes).
 * Stops pinging if the user is idle, letting the session expire naturally.
 */
(function() {
  var PING_INTERVAL = 15 * 60 * 1000;  // 15 minutes
  var IDLE_TIMEOUT  = 20 * 60 * 1000;  // 20 minutes
  var lastActivity  = Date.now();
  var pingTimer     = null;

  function updateActivity() {
    lastActivity = Date.now();
  }

  // Track user interaction
  document.addEventListener('keydown', updateActivity);
  document.addEventListener('click', updateActivity);
  document.addEventListener('scroll', updateActivity);

  function ping() {
    if (document.hidden) return;
    if (Date.now() - lastActivity > IDLE_TIMEOUT) return;

    $.get('/session/ping').fail(function(jqXHR) {
      if (jqXHR.status === 401 || jqXHR.status === 419) {
        clearInterval(pingTimer);
        window.location.href = '/login';
      }
    });
  }

  pingTimer = setInterval(ping, PING_INTERVAL);
})();

function toggle(className, displayState){
  var elements = document.getElementsByClassName(className);
  for (var i = 0; i < elements.length; i++){
      elements[i].style.display = displayState;
  }
}

function formatState(state) {
  const option = $(state.element);
  const colour = option.data("colour");

  if (!colour) {
    return state.text;
  }
  return $(`<span style="border-left: 20px solid ${colour}; padding-left: 4px;">${state.text}</span>`);
};

var eventConfig = {
  type: 'events',
  url: '/calendar/events',
  method: 'GET',
  // No source-level colour: the feed tags each event with kliq-event-* and
  // app.scss styles them as a tint with dark text.

  extraParams: {
    feedType: 'event',
  }
};

var bookingConfig = {
  type: 'bookings',
  url: '/calendar/bookings',
  method: 'GET',
  color: window.kliqPrimaryColour(),
  textColor: '#ffffff',
  
  extraParams: {
    feedType: 'booking',
  }
};

var sources = [eventConfig, bookingConfig];

document.addEventListener('DOMContentLoaded', function() {

  var tabEl = document.querySelectorAll('button[data-bs-toggle="tab"]')
  tabEl.forEach((tab) => {
    tab.addEventListener('show.bs.tab', function (event) {
      $($.fn.dataTable.tables(true)).DataTable().columns.adjust().responsive.recalc();
    })
  })

  /***
   * Global property selection of portal
   */
  $('.property-selection-dropdown').select2({
    theme: 'bootstrap-5',
    placeholder: 'Choose Property...'
  });

  $('.property-selection-dropdown').on('select2:select', function (e) {
    var data = e.params.data;
    window.location.href = '/global-property-selection/'+data.id
  });

  $(".searchable-select").select2({
      theme: "bootstrap-5",
      placeholder: 'Please choose...'
  });

  if($('.selectable-search-filters-row').length > 0){
    $('.selectable-search-filters-row').show();
  }

  /**
   * Event location dropdown for freetext "other"
   */
  $('#event_location_dropdown').on('change', function(e){
    let selectedValue = $(this).val();
    if(selectedValue === 'other'){
      $('.event-location-other').fadeIn();
      $('.event-location-other input').focus();
    }else{
      $('.event-location-other').fadeOut();
    }
    $('.event-location-other input').val('');
  });

  /** 
   * Generic datatable configuration
   */
   if(document.getElementsByClassName('hfs-data-table').length > 0){

    let table = new dt('.hfs-data-table', {
      "order": [],
      "autoWidth": false,
      "responsive": {
        details: {
            type: 'column',
            target: 'tr'
        }
      },
      "initComplete": function(settings, json) {
          toggle('hfs-spinner', 'none');
          toggle('hfs-table', 'table');
          toggle('hfs-card-nav', 'flex');
      }
    });
  }

  /** 
   * Generic user datatable configuration
   */
  if(document.getElementsByClassName('hfs-data-user-table').length > 0){

    if(document.getElementsByClassName('hfs-data-user-table')[0].dataset.archive){
      var archive = true;
      var archiveStr = '&archive=true';
      var columns = [
        { 
          data: 'name',
          render: function(data, type, row) {
            return userName(data, type, row);
          },
          className: 'align-middle'
        },
        { 
          data: 'user_level',
          render: function(a,b,c){
            return '<span class="badge bg-success text-light">'+escapeHtml(c.user_level)+'</span>';
          },
          className: 'align-middle'
        },
        { 
          data: 'actions', 
          render: function(data, type, row){
            return userArchiveButtons(data, type, row);
          },
          className: 'align-middle text-end'
        },
      ];
    }else{
      var archive = false;
      var archiveStr = '';
      var userFilter = getParameterByName('filter');

      switch(userFilter){

        // residents
        case '5':
          var columns = [
            {
              data: null,
              orderable: false,
              className: 'select-checkbox align-middle',
              targets:   0,
              render: function(){
                return '';
              }
            },
            { 
              data: 'name',
              render: function(data, type, row) {
                return userName(data, type, row);
              },
              className: 'align-middle',
              width: 120,
            },
            { 
              data: 'known_as', 
              className: 'align-middle',
              width: 80,
              render: function(data) {
                if(data != null){
                  return '<h6 class="mb-1 text-xs">'+escapeHtml(data)+'</h6>';
                }else{
                  return '';
                }
              }
            },
            { 
              data: 'last_name', 
              className: 'align-middle',
              width: 100,
              render: function(data) {
                return '<h6 class="mb-1 text-xs">'+escapeHtml(data)+'</h6>';
              }
            },
            {
              data: 'room_number',
              className: 'align-middle',
              width: 65,
              render: function(data) {
                return escapeHtml(data);
              }
            },
            // { 
            //   data: 'rebooked',
            //   render: function(a,b,c){
            //     return userRebooked(a);
            //   },
            //   className: 'align-middle',
            //   width: 60
            // },
            { 
              data: 'enabled', 
              render: function(a,b,c){
                return userEnabled(a,b,c);
              },
              className: 'align-middle',
              width: 25
            },
            { 
              data: 'app_active_at', 
              className: 'align-middle',
              width: 75,
              render: function(data){
                return data;
              }
            },
            { 
              data: 'birth_day', 
              className: 'align-middle',
              width: 65,
              render: function(data,b,row){
                if(row.birth_day != null && row.birth_month != null){
                  return row.birth_day+'/'+row.birth_month;
                }else{
                  return '- / -';
                }
              }
            },
            { 
              data: 'actions', 
              render: function(data, type, row){
                return userButtons(data, type, row);
              },
              className: 'align-middle text-end',
              
            },
          ];
        break;
        
        // the rest
        case '1':
        case '2':
        case '3':
        case '4':
        case '6':
        case '7':
        case '8':
        case '9':
        case '10':
          var columns = [
            {
              data: null,
              orderable: false,
              className: 'select-checkbox align-middle',
              targets:   0,
              render: function(){
                return '';
              }
            },
            { 
              data: 'name',
              render: function(data, type, row) {
                return userName(data, type, row);
              },
              className: 'align-middle',
              width: 120
            },
            { 
              data: 'known_as', 
              className: 'align-middle',
              width: 80,
              render: function(data) {
                if(data != null){
                  return '<h6 class="mb-1 text-xs">'+escapeHtml(data)+'</h6>';
                }else{
                  return '';
                }
              }
            },
            { 
              data: 'last_name', 
              className: 'align-middle',
              width: 100,
              render: function(data) {
                return '<h6 class="mb-1 text-xs">'+escapeHtml(data)+'</h6>';
              }
            },
            {
              data: 'room_number',
              className: 'align-middle',
              width: 65,
              render: function(data) {
                return escapeHtml(data);
              }
            },
            { 
              data: 'user_level',
              render: function(a,b,c){
                return '<span class="badge bg-success text-light">'+escapeHtml(c.user_level)+'</span>';
              },
              className: 'align-middle'
            },
      
            { 
              data: 'enabled', 
              render: function(a,b,c){
                return userEnabled(a,b,c);
              },
              className: 'align-middle',
              width: 25
            },
            { 
              data: 'app_active_at', 
              className: 'align-middle',
              width: 75,
              render: function(data){
                return data;
              }
            },
            { 
              data: 'actions', 
              render: function(data, type, row){
                return userButtons(data, type, row);
              },
              className: 'align-middle text-end',
              width: 360
            },
          ];
        break;


        // default columns
        default:
          var columns = [
            {
              data: null,
              orderable: false,
              className: 'select-checkbox align-middle',
              targets:   0,
              render: function(){
                return '';
              }
            },
            { 
              data: 'name',
              render: function(data, type, row) {
                return userName(data, type, row);
              },
              className: 'align-middle'
            },
            { 
              data: 'known_as', 
              className: 'align-middle',
              width: 80,
              render: function(data) {
                if(data != null){
                  return '<h6 class="mb-1 text-xs">'+escapeHtml(data)+'</h6>';
                }else{
                  return '';
                }
              }
            },
            { 
              data: 'last_name', 
              className: 'align-middle',
              width: 100,
              render: function(data) {
                return '<h6 class="mb-1 text-xs">'+escapeHtml(data)+'</h6>';
              }
            },
            {
              data: 'room_number',
              className: 'align-middle',
              width: 65,
              render: function(data) {
                return escapeHtml(data);
              }
            },
            { 
              data: 'user_level',
              render: function(a,b,c){
                return '<span class="badge bg-success text-light">'+escapeHtml(c.user_level)+'</span>';
              },
              className: 'align-middle'
            },
            // { 
            //   data: 'rebooked',
            //   render: function(a,b,c){
            //     return userRebooked(a);
            //   },
            //   className: 'align-middle',
            //   width: 60
            // },
            { 
              data: 'enabled', 
              render: function(a,b,c){
                return userEnabled(a,b,c);
              },
              className: 'align-middle',
              width: 25
            },
            { 
              data: 'app_active_at', 
              className: 'align-middle',
              width: 75,
              render: function(data){
                return data;
              }
            },
            
            { 
              data: 'actions', 
              render: function(data, type, row){
                return userButtons(data, type, row);
              },
              className: 'align-middle text-end',
              width: 360
            },
          ];
        break;
      }
    }

    function userButtons(data, display, row){
      
      var token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

      var postAndPushButtons = '';
      if(row.user_level_id == 5) {
        postAndPushButtons += `
          <a href="javascript:void(0)" class="btn btn-primary btn-sm btn-send-mail-notification" data-name="`+escapeHtml(row.name)+`" data-id="`+row.id+`" data-toggle="tooltip">
            <i class="fa fa-cube fa-fw"></i> Post
          </a>
          <a href="javascript:void(0)" data-name="`+escapeHtml(row.name)+`" data-id="`+row.id+`" class="btn btn-secondary btn-send-push text-white btn-sm">
            <i class="fa fa-bell fa-fw"></i>
            <span>Push</span>
          </a>`;
      }
      var btnHTML = `
      <div class="btn-group">
        `+postAndPushButtons+`
        <a href="/users/`+data+`" class="btn btn-outline-secondary btn-sm" data-toggle="tooltip" title="Edit user">
          <i class="fa fa-eye fa-fw"></i> Show
        </a>
        <a href="/users/`+data+`/edit" class="btn btn-outline-secondary btn-sm" data-toggle="tooltip" title="Edit user">
          <i class="fa fa-pencil fa-fw"></i> Edit
        </a>
        <form method="POST" action="/users/`+data+`" accept-charset="UTF-8" `+confirmSubmitAttr('Do you really want to archive the user ' + row.name + '?')+`>
        <input name="_method" type="hidden" value="DELETE">
        <input name="_token" type="hidden" value="`+token+`">

          <button type="submit" class="btn btn-outline-danger hfs-btn-table-delete btn-sm">
            <i class="fa fa-trash fa-fw"></i> Archive
          </button>
        </form>
      </div>`;
      
      return btnHTML;

    };

    function userArchiveButtons(data, display, row){
      
      var token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

      var btnHTML = `
      <div class="btn-group">
      <form method="POST" action="/users/archive/restore" accept-charset="UTF-8" `+confirmSubmitAttr('Do you really want to restore the user ' + row.name + '?')+`>
        <input name="_method" value="DELETE" type="hidden" />
        <input name="restore_id" type="hidden" value="`+data+`">
        <input name="_token" type="hidden" value="`+token+`">

        <button type="submit" class="btn btn-outline-success  me-1 btn-sm">
          <i class="fa-solid fa-trash-arrow-up fa-fw"></i> Restore
        </button>
      </form>
      <form method="POST" action="/users/archive/delete" accept-charset="UTF-8" `+confirmSubmitAttr('Do you really want to permanently delete the user ' + row.name + '?')+`>
        <input name="_method" value="DELETE" type="hidden" />
        <input name="permanent_delete_id" type="hidden" value="`+data+`">
        <input name="_token" type="hidden" value="`+token+`">

          <button type="submit" class="btn btn-outline-danger  btn-sm">
            <i class="fa-solid fa-trash fa-fw"></i> Delete
          </button>
        </form>
      </div>`;
      
      return btnHTML;

    };

    function userName(data,display,row){
      var propertiesList = '';
      
      row.properties.forEach(obj =>  {
        propertiesList += escapeHtml(obj)+'<br />';
      });

      var tooltipContent = '';
      tooltipContent += ``+escapeHtml(row.email);
      if(row.user_level_id > 2){
        tooltipContent += `<br /><strong>Properties:</strong><br />`+propertiesList+``;
      }
      var userHTML = `
      <div class="d-flex px-2 py-1" data-bs-toggle="tooltip" title="`+tooltipContent+`" data-bs-placement="left" data-bs-fallbackPlacements="['top', 'right', 'bottom']" data-bs-html="true">
        <div>`;
        if(!row.image_url){
          userHTML += `<img class="avatar avatar-sm me-2" src="/assets/img/placeholder.webp">`;
        }else{
          userHTML += `<img class="avatar avatar-sm me-2" src="`+escapeHtml(row.image_url)+`">`;
        }
      if(row.room_number == null) {
        var roomNo = '';
      }else{
        var roomNo = row.room_number;
      }
      //<small>`+roomNo+`</small>
      userHTML += `
        </div>
        <div class="d-flex flex-column justify-content-center">
          <h6 class="mb-0 text-xs">`+escapeHtml(row.first_name)+`</h6>
        </div>
      </div>`;

      return userHTML;
    };

    function userEnabled(data,b,c){

      var enabled = `
      <a href="javascript: void(0)" class="toggle-record" 
        data-table="users" 
        data-id="`+c.id+`" 
        data-column="enabled">`;

      if(data === 1){
        enabled += '<span class="badge text-light rounded-pill bg-success"><i class="fa fa-check fa-fw"></i></span>';
      }else{
        enabled += '<span class="badge bg-danger rounded-pill"><i class="fa fa-remove fa-fw"></i></span>';
      }

      enabled += `</a>`;
      return enabled;
    };

    // function userEnabled(data){
    //   if(data === 1){
    //     var enabled = '<span class="badge text-light rounded-pill bg-success"><i class="fa fa-check fa-fw"></i></span>';
    //   }else{
    //     var enabled = '<span class="badge bg-danger rounded-pill"><i class="fa fa-remove fa-fw"></i></span>';
    //   }
    //   return enabled;
    // };

    function userRebooked(data){
      switch(data){
        case 1:
          var enabled = '<span class="badge text-light rounded-pill bg-success"><i class="fa fa-check fa-fw"></i></span>';
        break;

        case 2: 
        var enabled = '<span class="badge text-light rounded-pill bg-danger"><i class="fa fa-remove fa-fw"></i></span>';
        break;

        default:
        var enabled = '<span class="badge bg-warning rounded-pill"><i class="fa fa-info-circle fa-fw"></i></span>';
        break;
      }

      return enabled;
    };

    let table = new dt('.hfs-data-user-table', {
      // processing: true,
      serverSide: true,
      lengthMenu: [ [10, 25, 50, 100, 200], [10, 25, 50, 100, 200] ],
      columns: columns,
      select: {
        style: 'multi',
        selector: 'td:first-child'
      },
      rowId: 'id',
      order: (getParameterByName('showOnlyActive') == 'upcomingBirthdays') ? [[ 7, 'asc' ]] : [[ 1, 'asc' ]],
      ajax: '/users/response/json?filter='+getParameterByName('filter')+'&showOnlyActive='+getParameterByName('showOnlyActive')+archiveStr,
      "autoWidth": false,
      "responsive": {
        details: {
            type: 'column',
            target: 'tr'
        }
      },
      "initComplete": function(settings, json) {
          toggle('hfs-spinner', 'none');
          toggle('hfs-table', 'table');
          toggle('hfs-card-nav', 'flex');
      }
    });

    var selectedUsers = [];
    table.on("init.dt", function () {

        var button = '<label class="me-3">';
        button += '<select class="form-control form-control-sm ms-3" name="showOnlyActive">';
        button += '<option value=""';
        if(getParameterByName('showOnlyActive') == 'null' || getParameterByName('showOnlyActive') == ''){
          button += ' selected';
        }
        button += '>Show All Users</option>';
        button += '<option value="active"';
        if(getParameterByName('showOnlyActive') == 'active'){
          button += ' selected';
        }
        button += '>Show Only Active</option>';
        button += '<option value="inactive"';
        if(getParameterByName('showOnlyActive') == 'inactive'){
          button += ' selected';
        }
        button += '>Show Non Active</option>';
        button += '<option value="upcomingBirthdays"';
        if(getParameterByName('showOnlyActive') == 'upcomingBirthdays'){
          button += ' selected';
        }
        button += '>Show Upcoming Birthdays</option>';
        button += '</select>';
        button += '</label>';

        $(".dataTables_filter").append(button);

    });
    // on select, push to selectedUsers array (...if not already in array)
    table.on( 'select', function ( e, dt, type, indexes ) {
      if ( type === 'row' ) {
        var data = table.rows( indexes ).data().pluck( 'id' );
        if(selectedUsers.indexOf(data[0]) === -1){
          selectedUsers.push(data[0]);
          $('.bulk-number-counter').text(selectedUsers.length);
          // show bulk sending...
          $('.bulk-parcel-selection').fadeIn();
        }
      }
    });

    // on de-select remove from selectedUsers Array
    table.on( 'deselect', function ( e, dt, type, indexes ) {
      if ( type === 'row' ) {
        var data = table.rows( indexes ).data().pluck( 'id' );
        for( var i = 0; i < selectedUsers.length; i++){ 
          if ( selectedUsers[i] === data[0]) { 
            selectedUsers.splice(i, 1); 
          }
        }

        $('.bulk-number-counter').text(selectedUsers.length);
        if(selectedUsers.length === 0){
          $('.bulk-parcel-selection').fadeOut();
        }
      }
    });

    // on draw, keep programatic selectedUsers
    table.on( 'draw', function (e, dt, type, indexes) {
      selectedUsers.forEach(function(userId){
        var rowId = table.row('#'+userId);
        rowId.select();
      })
      enableBootstrapTooltips();
    });

    $(document).on('click', '.btn-send-bulk-deselect-all', function(e){
      
      // deselect all
      table.rows().deselect();

      // empty array
      selectedUsers = [];

      // set number to 0
      $('.bulk-number-counter').text(0);

      // hide bulk header
      $('.bulk-parcel-selection').fadeOut();

    })

    $(document).on('change', 'select[name=showOnlyActive]', function(){
      window.location.href = '/users?filter='+getParameterByName('filter')+'&showOnlyActive='+$(this).val();
    })
    $(document).on('click', '.btn-send-bulk-mail', function(){
      let totalUsers = selectedUsers.length;

      if(totalUsers === 0){
        Swal.fire(
          'Error!',
          'Please select users before sending a post notifcation.',
          'error'
        );

        return false;
      }

      Swal.fire({
        title: 'Confirm',
        text: "Are you sure you want to send "+totalUsers+" users a post notification?",
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: window.kliqPrimaryColour(),
        cancelButtonColor: '#d33',
        confirmButtonText: 'Send Notifications'
      }).then((result) => {
  
        if (result.isConfirmed) {

          var object = {
            title: 'You\'ve got post!',
            body: 'Please make your way down to reception to pick up your post.',
            user_ids: selectedUsers,
            enabled: 1,
            content_type: 'mail',
            _token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            type: 'group',
            ajax: true
          };

          $.ajax({
            url: '/announcements',
            method: 'POST',
            data: object,
            success: function(response){
              if(response.success){

                Swal.fire(
                  'Success!',
                  'You have sent a post notification to <strong>'+totalUsers+'</strong> residents.',
                  'success'
                );
                selectedUsers = [];
                $('.bulk-parcel-selection').fadeOut();
                table.rows().deselect();

              }else{
                Swal.fire(
                  'Error!',
                  'Internal error sending post notification',
                  'error'
                );
              }
            },
            // A refused request (a 422 from validation, say a selected user
            // who is not a resident at this property) used to fail silently.
            error: function(xhr){
              Swal.fire('Not sent', escapeHtml(firstServerError(xhr, 'The post notification could not be sent.')), 'error');
              $('.bulk-parcel-selection').fadeIn();
            }
          });
        }

      })
  
    });
  
    $(document).on('click', '.btn-send-mail-notification', function(){
  
      let name = $(this).data('name');
      let userId = $(this).data('id');
      let additionalPostHtml = '';
      // let additionalPostHtml = `
      // <div class="form-group mt-2">
      //   <input class="form-control" placeholder="Optional post location..." name="post_location" id="post_location">
      // </div>`;
      Swal.fire({
        title: 'Confirm',
        // data() hands back the decoded attribute, so escape again for the HTML sink.
        html: "Are you sure you want to send "+escapeHtml(name)+" a post notification?"+additionalPostHtml,
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: window.kliqPrimaryColour(),
        cancelButtonColor: '#d33',
        confirmButtonText: 'Send Notification'
      }).then((result) => {

        if (result.isConfirmed) {

          var object = {
            title: 'You\'ve got post!',
            body: 'Please make your way down to reception to pick up your post.',
            user_id: userId,
            enabled: 1,
            content_type: 'mail',
            _token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            type: 'individual',
            ajax: true
          };
          //<div class="text-center"><div class="p-0 m-0" style="font-size: 1rem;">Code:</div><span style="color: #333; font-size: 4rem;">`+response.generatedCode+`</span></div><hr />
          $.ajax({
            url: '/announcements',
            method: 'POST',
            data: object,
            success: function(response){
              if(response.success){
                let additionalPostHtml = `
                <div class="form-group mt-4">
                  <input type="hidden" name="collectionId" id="collectionId" value="`+response.collectionId+`">
                  <div class="input-group">
                    <input class="form-control" placeholder="Optional post location..." name="post_location" id="post_location">
                    <button id="savePostLocation" class="btn btn-primary"><i class="fa fa-fw fa-save"></i>Save</button>
                  </div>
                </div>`;
                Swal.fire(
                  `<div class="text-center"><div class="p-0 m-0" style="font-size: 1rem;">Code:</div><span style="color: #333; font-size: 4rem;">`+response.generatedCode+`</span></div><hr />`,
                  'You have sent a post notification to <strong>'+escapeHtml(name)+'</strong>.'+additionalPostHtml,
                  'custom'
                );
              }else{
                Swal.fire(
                  'Error!',
                  'Internal error sending post notification',
                  'error'
                );
              }
            },
            error: function(xhr){
              Swal.fire('Not sent', escapeHtml(firstServerError(xhr, 'The post notification could not be sent.')), 'error');
            }
          });
        }
      })
  
    });

    var templateJson = $('input[name=pushTemplates]').val(),
    templateJson = JSON.parse(templateJson);
    var notificationTemplates = '<option value="">Select from Template...</option>';
    templateJson.forEach(function(template, key) {
      var title = '';
      
      if(template.name == null) {
        var title = template.title;
      }else{
        var title = template.name;
      }

      notificationTemplates += '<option value="'+key+'">'+escapeHtml(title)+'</option>';
    });

    $(document).on('change', '#notification_template', function(e){
      var thisSelected = $(this).val();
      if(thisSelected == ''){
        $('#notification_title').val('');
        $('#notification_body').val('');
        $('#button_text').val('');
        $('#button_link').val('');
      }else{
        $('#notification_title').val(templateJson[thisSelected].title);
        $('#notification_body').val(templateJson[thisSelected].body);
        $('#button_text').val(templateJson[thisSelected].button_text);
        $('#button_link').val(templateJson[thisSelected].button_link);
      }
    });
    
  
    var notificationPopupForm = `
      <div class="form-group text-start mb-3">
          <select class="form-control" name="notification_template" id="notification_template">${notificationTemplates}</select>
      </div>
      <div class="form-group text-start mb-3">
          <label for="notification_title" class="d-block mb-2">
              Title
          </label>
          <input type="text" maxlength="65" id="notification_title" class="form-control" placeholder="Push Notification Title">
          <small class="d-block mt-2">Title has a maximum length of 65 characters.</small>
      </div>
      <div class="form-group text-start">
          <label for="notification_body" class="d-block mb-2">
              Body
          </label>
          <textarea id="notification_body" maxlength="178" class="form-control" placeholder="Push Notification Body"></textarea>
          <small class="d-block mt-2">Body has a maximum length of 178 characters.</small>
      </div>
      <input type="hidden" name="button_text" value="" id="button_text">
      <input type="hidden" name="button_link" value="" id="button_link">`;
  
    $(document).on('click', '.btn-send-bulk-push', function(){
      let totalUsers = selectedUsers.length;

      if(totalUsers === 0){
        Swal.fire(
          'Error!',
          'Please select users before sending a push notification.',
          'error'
        );
        return false;
      }
  
      Swal.fire({
        title: 'Send Push Notification to <strong>'+totalUsers+'</strong> users.',
        html: notificationPopupForm,
        confirmButtonText: 'Send Push Notifications',
        showCancelButton: true,
        focusConfirm: false,
        preConfirm: () => {
          const title = Swal.getPopup().querySelector('#notification_title').value;
          const body = Swal.getPopup().querySelector('#notification_body').value;
          const btn = Swal.getPopup().querySelector('#button_text').value;
          const link = Swal.getPopup().querySelector('#button_link').value;
          if (!title || !body) {
            Swal.showValidationMessage(`Please enter title and body`)
          }
          return { title: title, body: body, button_text: btn, button_link: link }
        }
      }).then((result) => {

        if(result.isConfirmed){ 
          var object = {
            title: result.value.title,
            body: result.value.body,
            button_text: result.value.button_text,
            button_link: result.value.button_link,
            user_ids: selectedUsers,
            content_type: 'standard',
            enabled: 1,
            _token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            type: 'group',
            ajax: true
          };
          $.ajax({
            url: '/announcements',
            method: 'POST',
            data: object,
            success: function(response){
              if(response.success){

                Swal.fire(
                  'Success!',
                  'You have sent a push notification to <strong>'+totalUsers+'</strong> users.',
                  'success'
                );

                selectedUsers = [];
                $('.bulk-parcel-selection').fadeOut();
                // deselect all selected
                table.rows().deselect();

              }else{
                Swal.fire(
                  'Error!',
                  'Internal error sending push notification',
                  'error'
                );
              }
            },
            error: function(xhr){
              Swal.fire('Not sent', escapeHtml(firstServerError(xhr, 'The push notification could not be sent.')), 'error');
            }
          });
        }

      })
  
    });
  
    $(document).on('click', '.btn-send-push', function(){
      
      let name = $(this).data('name');
      let userId   = $(this).data('id');
  
      Swal.fire({
        title: 'Send Push Notification to '+escapeHtml(name),
        html: notificationPopupForm,
        confirmButtonText: 'Send Push Notification',
        showCancelButton: true,
        focusConfirm: false,
        preConfirm: () => {
          const title = Swal.getPopup().querySelector('#notification_title').value
          const body = Swal.getPopup().querySelector('#notification_body').value
          const btn = Swal.getPopup().querySelector('#button_text').value;
          const link = Swal.getPopup().querySelector('#button_link').value;
          if (!title || !body) {
            Swal.showValidationMessage(`Please enter title and body`)
          }
          return { title: title, body: body, button_text: btn, button_link: link }
        }
      }).then((result) => {

        var object = {
          title: result.value.title,
          body: result.value.body,
          button_text: result.value.button_text,
          button_link: result.value.button_link,
          user_id: userId,
          enabled: 1,
          content_type: 'standard',
          _token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
          type: 'individual',
          ajax: true
        };

        if(result.isConfirmed){

          $.ajax({
            url: '/announcements',
            method: 'POST',
            data: object,
            success: function(response){
              if(response.success){
                Swal.fire(
                  'Success!',
                  'You have sent a push notification to <strong>'+escapeHtml(name)+'</strong>.',
                  'success'
                );
              }else{
                Swal.fire(
                  'Error!',
                  'Internal error sending push notification',
                  'error'
                );
              }
            },
            error: function(xhr){
              Swal.fire('Not sent', escapeHtml(firstServerError(xhr, 'The push notification could not be sent.')), 'error');
            }
          })

          
        }
      })
  
    });

  }
  /**
   * Datatable configuration for re-orderable tables
   */
  if(document.getElementsByClassName('hfs-data-table-reorder').length > 0){

    let tableOrderable = new dt('.hfs-data-table-reorder', {
      order: [[0, 'asc']],
      rowReorder: true,
      "autoWidth": false,
      "responsive": {
        details: {
            type: 'column',
            target: 'tr'
        }
      },
      "initComplete": function(settings, json) {
          toggle('hfs-spinner', 'none');
          toggle('hfs-table', 'table');
          toggle('hfs-card-nav', 'flex');
      }
    });

    tableOrderable.on( 'row-reorder', function ( e, diff, edit ) {

      var updates = [];
      diff.forEach((element, key) => {

          updates.push({
            'record_id': element.node.dataset.rowId,
            'order': element.newData
          });
      });

      $.ajax({
        url: '/banners/order',
        method: 'post',
        data: {
          updates: updates,
          _token: document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        },
        success: function() {
          // order updated
        }
      });

    });

  }

  /**
   * Drag and drop upload for sections (communal spaces, events, etc.)
   */
  if(document.getElementById('dropzone-upload-form') !== null){
    // init dropzone
    let myDropzone = new Dropzone("#dropzone-upload-form", {
      addRemoveLinks: true,
      headers: {
        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      }
    });
    // on file upload success, append to the body to capture in the store/update method.
    myDropzone.on("success", function(file, response) {
      $(file.previewElement).append( $('<input type="hidden" name="image_files[]" id="image_files[]" class="image_files dz-media-id" value="' + response +'">') );
    });
  }

  /**
   * Drag and drop upload for sections events post form
   */
  if(document.getElementById('dropzone-upload-form-post-event') !== null){
    // init dropzone
    let myDropzone = new Dropzone("#dropzone-upload-form-post-event", {
      addRemoveLinks: true,
      headers: {
        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      }
    });
    // on file upload success, append to the body to capture in the store/update method.
    myDropzone.on("success", function(file, response) {
      $(file.previewElement).append( $('<input type="hidden" name="post_event_image_files[]" id="post_event_image_files[]" class="post_event_image_files dz-media-id" value="' + response +'">') );
    });
  }

  /**
   * Main Calendar
   */
  var calendarEl = document.getElementById('calendar');
  if(calendarEl !== null){

    // searchable lists
    $('#user_id').select2({
      placeholder: 'Choose user...',
      theme: "bootstrap-5",
    });

    $('#user_id').on('select2:select', function (e) {
      // Do something
      var data = e.params.data;

      // if "other" selected, show free text field.
      if(data.id == 'other') {
        
        $('#calendar-free-text-field-container').show();

        // small delay, give the ui time to show the element
        setTimeout(function(){
          $('#calendar-free-text-field').focus();
        }, 500);

      }else{
        // empty & hide
        $('#calendar-free-text-field').val('');
        $('#calendar-free-text-field-container').hide();
      }

    });

    $('#communal_space_id').select2({
      theme: "bootstrap-5",
      templateResult: formatState,
      templateSelection: formatState,
      placeholder: 'Choose space...'
    });

    //interactionPlugin, dayGridPlugin, timeGridPlugin, listPlugin
    const nowDateTime = new Date();
    let currentHour = nowDateTime.getHours()+':00:00';
    var calendar = new Calendar(calendarEl, {
      themeSystem: 'bootstrap5',
      plugins: [interactionPlugin, dayGridPlugin, timeGridPlugin, listPlugin],
      headerToolbar: {
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
      },
      initialView: ($(window).width() > 768) ? 'dayGridMonth' : 'listWeek',
      initialDate: new Date(),
      navLinks: true, // can click day/week names to navigate views
      editable: false,
      //slotDuration:'01:00:00',
      timeZone: 'GMT',
      selectable: true,
      locale: 'en-gb',
      // slotMinTime: '9:00:00',
      // slotMaxTime: '17:30:00',
      displayEventTime: true,
      nowIndicator: true,
      dayMaxEvents: true, // allow "more" link when too many events
      eventSources: sources,
      eventTimeFormat: { // like '14:30:00'
        hour: '2-digit',
        minute: '2-digit',
        meridiem: 'short'
      },
      scrollTime: currentHour,
      select: function(info) {
        $('#start_datetime').val(info.startStr);
        $('#end_datetime').val(info.endStr);
      },
      eventClick: function(eventClickInfo) {
        enableEventEdit(eventClickInfo.event);
      }
    });

    $('.hfs-spinner').hide();

    calendar.render();

    var eventsOn = true;
    var bookingsOn = true;

    document
    .getElementById('events')
    .addEventListener('change', function() {
      if (this.checked) {
        calendar.addEventSource(eventConfig);
      } else {
        calendar.getEventSources().forEach(function(source){
          if(source.internalEventSource.extendedProps.type == 'events'){
            source.remove();
            calendar.refetchEvents();
          }
        });
      }
    });

    document
    .getElementById('communalBookings')
    .addEventListener('change', function() {
      if (this.checked) {
        calendar.addEventSource(bookingConfig);
      } else {
        calendar.getEventSources().forEach(function(source){
          if(source.internalEventSource.extendedProps.type == 'bookings'){
            source.remove();
            calendar.refetchEvents();
          }
        });
      }
    });

    document.getElementById('start_datetime')
    .addEventListener('change', function() {
      calendar.changeView('timeGridDay', document.getElementById('start_datetime').value);
      $('#end_datetime').val(document.getElementById('start_datetime').value)
    });

    document.getElementById('add-booking')
    .addEventListener('click', function() {

      var user_id       = $('#user_id').val(),
      communal_space_id = $('#communal_space_id').val(),
      startDateTime     = $('#start_datetime').val(),
      endDateTime       = $('#end_datetime').val(),
      freeText          = $('#calendar-free-text-field').val();

      var bookingObject = {
        user_id: $('#user_id').val(),
        communal_space_id: $('#communal_space_id').val(),
        start_datetime: $('#start_datetime').val(),
        end_datetime: $('#end_datetime').val(),
        free_text: freeText,
        ajax: true,
        edit: false,
        _token: document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      };
      
      if(bookingObject.user_id == '') {
        $('#user_id').focus();
        Swal.fire(
          'Error',
          'User is required to be selected.',
          'error'
        );
        return false;
      }

      if(bookingObject.communal_space_id == '') {
        $('#communal_space_id').focus();
        Swal.fire(
          'Error',
          'Communal space is required to be selected.',
          'error'
        );
        return false;
      }

      $.ajax({
        method: 'POST',
        url: '/communal-space/'+communal_space_id+'/bookings',
        dataType: 'json',
        data: bookingObject,
        success: function(response) {
          
          // notify user
          //alert('Booking successfully added to the calendar.');
          Swal.fire(
            'Booking Confirmed',
            'Your booking successfully has been added to the calendar.',
            'success'
          );
          // reload calendar
          calendar.refetchEvents();
          
          // reset selections
          $('#user_id').val('').trigger('change');
          $('#communal_space_id').val('').trigger('change');
        
        },
        error: function(error) {
          Swal.fire(
            'Error',
            error.responseJSON.message,
            'error'
          );
        }
      })

    });

    document.getElementById('edit-booking')
    .addEventListener('click', function() {

      var user_id       = $('#user_id').val(),
      communal_space_id = $('#communal_space_id').val(),
      startDateTime     = $('#start_datetime').val(),
      endDateTime       = $('#end_datetime').val(),
      freeText          = $('#calendar-free-text-field').val();

      var bookingObject = {
        booking_id: $('#booking_id').val(),
        user_id: $('#user_id').val(),
        communal_space_id: $('#communal_space_id').val(),
        start_datetime: $('#start_datetime').val(),
        end_datetime: $('#end_datetime').val(),
        free_text: freeText,
        ajax: true,
        edit: true,
        _token: document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      };
      
      if(bookingObject.user_id == '') {
        $('#user_id').focus();
        Swal.fire(
          'Error',
          'User is required to be selected.',
          'error'
        );
        return false;
      }

      if(bookingObject.communal_space_id == '') {
        $('#communal_space_id').focus();
        Swal.fire(
          'Error',
          'Communal space is required to be selected.',
          'error'
        );
        return false;
      }

      $.ajax({
        method: 'PATCH',
        url: '/communal-space/'+communal_space_id+'/bookings/'+bookingObject.booking_id,
        dataType: 'json',
        data: bookingObject,
        success: function(response) {
          
          // notify user
          //alert('Booking successfully added to the calendar.');
          Swal.fire(
            'Booking Edited',
            'Your booking successfully has been edited.',
            'success'
          );
          // reload calendar
          calendar.refetchEvents();
          
          // reset selections
          $('#user_id').val('').trigger('change');
          $('#communal_space_id').val('').trigger('change');
          $('#calendar-free-text-field-container').hide();

          enableEventAdd();
        
        },
        error: function(error) {
          Swal.fire(
            'Error',
            error.responseJSON.message,
            'error'
          );
        }
      })

    });

    var startUpdated = false;

    calendar.on('dateClick', function(info) {
      if(!startUpdated){
        $('#start_datetime').val(info.dateStr);
        $('#start_datetime').addClass('selection-success');
        setTimeout(function(){
          $('#start_datetime').removeClass('selection-success');
        },2000);
        startUpdated = true;
      }
      if(startUpdated){
        $('#end_datetime').val(info.dateStr);
        $('#end_datetime').addClass('selection-success');
        setTimeout(function(){
          $('#end_datetime').removeClass('selection-success');
        },2000);
      }
    });

    if(getParameterByName('addCommunalBooking')) {
      calendar.changeView('timeGridDay');
    }
  }
  /**
   * End Main Calendar
   */

  /** mini calendar  **/
  var calendarElMini = document.getElementById('calendar-mini');
  if(calendarElMini !== null){

    const nowDateTime = new Date();
    let currentHour = nowDateTime.getHours()+':00:00';

    //interactionPlugin, dayGridPlugin, timeGridPlugin, listPlugin
    var calendarMini = new Calendar(calendarElMini, {
      themeSystem: 'bootstrap5',
      plugins: [interactionPlugin, dayGridPlugin, timeGridPlugin, listPlugin],
      headerToolbar: {
        right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
      },
      initialDate: new Date(),
      initialView: ($(window).width() > 768) ? 'timeGridWeek' : 'listWeek',
      
      navLinks: true, // can click day/week names to navigate views
      editable: false,
      timeZone: 'GMT',
      selectable: true,
      locale: 'en-gb',
      displayEventTime: true,
      nowIndicator: true,
      dayMaxEvents: true, // allow "more" link when too many events
      eventSources: sources,
      eventTimeFormat: { // like '14:30:00'
        hour: '2-digit',
        minute: '2-digit',
        meridiem: 'short'
      },
      height: 420,
      scrollTime: currentHour
    });

    $('.hfs-spinner').hide();

    calendarMini.render();
  }
  /** end mini calendar **/

  $('#switch-booking-form').on('click', function(e){
    enableEventAdd();
  });

  $(document).on('click', '.toggle-record', function(e){
    
    e.preventDefault();

    let table   = $(this).data('table');
    let column  = $(this).data('column');
    let id      = $(this).data('id');
    let element = $(this);
    let before  = element.html();

    element.html(`<span class=""><i class="fas text-primary fa-circle-notch fa-spin"></i></span>`);

    $.ajax({
      url: '/toggleRecord',
      data: {
        table: table,
        column: column,
        id: id,
        _token: document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      },
      method: 'POST',
      success: function(response) {
        if(response.success){

          if(response.current == null) {
            var html = '<span class="badge bg-danger rounded-pill"><i class="fa fa-remove fa-fw"></i></span>';
          }else{
            var html = '<span class="badge text-light rounded-pill bg-success"><i class="fa fa-check fa-fw"></i></span>';
          }

          element.html(html);

        }else{
          element.html(before);
        }
      },
      // The server refuses toggles the user is not allowed to make (401),
      // so put the badge back as it was and say so, rather than leaving the
      // spinner running.
      error: function(xhr) {
        element.html(before);

        var message = xhr.status === 401 || xhr.status === 403
          ? 'You do not have permission to change this record.'
          : 'The change could not be saved. Please try again.';

        Swal.fire({ icon: 'error', title: 'Not changed', text: message });
      }
    });

  });

  $(document).on('click', '#savePostLocation', function(e){
    e.preventDefault();
    let thisEl = $(this);

    thisEl.html('<i class="fas text-white fa-circle-notch fa-spin"></i> Saving...');
  
    $.ajax({
      url: '/parcel-collections/saveLocation',
      data: {
        collectionId: $('#collectionId').val(),
        location: $('#post_location').val(),
        _token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      },
      method: 'POST',
      success: function(resp){
        if(resp.success){
          thisEl.html('<i class=" text-white fa fa-check "></i> Saved');
        }
      }
    })
  });

  
  enableBootstrapTooltips();

});


function enableBootstrapTooltips() {
  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl)
  })
}
/**
 * 
 * @param {*} eventData 
 * @returns Event data for calendar, populates sidebar with
 * rel booking info.
 */
function enableEventEdit(eventData) {

  if(eventData.extendedProps.type == 'event') {
    window.open('/events/' + eventData.extendedProps.event_id + '/edit', '_blank');
    return false;
  }

  
  var editAddFormContainer = $('.calendar-edit-add-form');
  editAddFormContainer.find('h5.heading').text('Edit Space Booking');

  // if booking
  editAddFormContainer.find('#booking_id').val(eventData.extendedProps.booking_id);

  // set start local
  if(eventData.extendedProps.start_local){
    editAddFormContainer.find('#start_datetime').val(eventData.extendedProps.start_local);
  }

  // set end local
  if(eventData.extendedProps.end_local){
    editAddFormContainer.find('#end_datetime').val(eventData.extendedProps.end_local);
  }

  // set default resident

  if(!eventData.extendedProps.user_id) {
    $('#user_id').val('other');
    $('#calendar-free-text-field-container').show();
    $('#calendar-free-text-field').val(eventData.extendedProps.free_text);
  }else{
    $('#calendar-free-text-field').val('');
    $('#calendar-free-text-field-container').hide();
    $('#user_id').val(eventData.extendedProps.user_id);
  }
  $('#user_id').trigger('change');

  // set default room
  $('#communal_space_id').val(eventData.extendedProps.communal_space_id);
  $('#communal_space_id').trigger('change');

  // show edit btn
  $('.edit-column').show();
  $('.add-column').hide();
  $('.new-booking-column').show();
}

/**
 * Clicking back from editing an event, reset to add form
 */
 function enableEventAdd() {
  var editAddFormContainer = $('.calendar-edit-add-form');
  editAddFormContainer.find('h5.heading').text('Book a Space');
  editAddFormContainer.find('#booking_id').val('');
  editAddFormContainer.find('#start_datetime').val('');
  editAddFormContainer.find('#end_datetime').val('');

  $('#calendar-free-text-field').val('');
  $('#calendar-free-text-field-container').hide();

  $('#user_id').val('');
  $('#user_id').trigger('change');

  // set default room
  $('#communal_space_id').val('');
  $('#communal_space_id').trigger('change');

  $('.edit-column').hide();
  $('.new-booking-column').hide();
  $('.add-column').show();
}

/**
 * 
 * @param {*} obj 
 * @returns boolean
 */
function isEmpty(obj) {
  return Object.keys(obj).length === 0;
}

/**
 *  if object is already in array
**/
function containsObject(obj, list) {
  var i;
  for (i = 0; i < list.length; i++) {
      if (list[i] === obj) {
          return true;
      }
  }

  return false;
}

/***
 * Determine if a element has been focused on
 */
function isFocused(element) {
  return document.getElementById(element) === document.activeElement;
}

/**
 * URL Param by name (eg. ?parcelManager=true)
 */
function getParameterByName(name, url = window.location.href) {
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
